import React from "react";
import { Box, Typography } from "@mui/material";
import ornamentalDivider from "../../../assets/Images/TempleDetail/mobile/ornamental-divider.svg";
import cardMandala from "../../../assets/Images/TempleDetail/mobile/card-mandala.svg";
import { T, FONT, HINDI_FONT } from "../shared";

// Building blocks of the mobile temple page — Figma "Mobile revamp" 739:17212.

// White section card with the faint mandala in its top-right corner.
// overflow stays visible when a child must stick (history); the mandala is clipped on its own.
export const MobileCard = ({ children, id, sx, watermark = true }) => (
  <Box
    component="section"
    id={id}
    sx={{
      position: "relative",
      background: "#FFFFFF",
      border: "0.5px solid rgba(201,149,43,0.3)",
      borderRadius: "20px",
      boxShadow: "0px 8px 24px 0px rgba(89,38,13,0.06)",
      p: "20px",
      display: "flex",
      flexDirection: "column",
      gap: "24px",
      scrollMarginTop: "16px",
      ...sx,
    }}
  >
    {watermark && (
      <Box aria-hidden="true" sx={{ position: "absolute", inset: 0, borderRadius: "inherit", overflow: "hidden", pointerEvents: "none" }}>
        <Box sx={{ position: "absolute", right: "-106.5px", top: "-96.5px", width: "228px", height: "228px", opacity: 0.09 }}>
          <Box component="img" src={cardMandala} alt="" sx={{ position: "absolute", left: "7%", top: "20%", width: "67.17%", height: "67.17%" }} />
        </Box>
      </Box>
    )}
    {children}
  </Box>
);

// "READ THE HISTORY ॥ इतिहास ॥" + title + ornamental divider.
export const MobileHeading = ({ eyebrow, hindi, title }) => (
  <Box sx={{ position: "relative", display: "flex", flexDirection: "column", gap: "6px", alignItems: "flex-start" }}>
    <Box sx={{ display: "flex", gap: "6px", alignItems: "center", color: T.gold }}>
      <Typography sx={{ fontFamily: FONT, fontWeight: 700, fontSize: "10px", lineHeight: "normal", letterSpacing: "0.8px", textTransform: "uppercase", color: T.gold }}>{eyebrow}</Typography>
      {hindi && <Typography sx={{ fontFamily: HINDI_FONT, fontSize: "14px", lineHeight: "normal", color: T.gold }}>{hindi}</Typography>}
    </Box>
    <Typography component="h2" sx={{ fontFamily: FONT, fontWeight: 700, fontSize: "23px", lineHeight: 1.35, color: T.ink, wordBreak: "break-word" }}>
      {title}
    </Typography>
    <Box component="img" src={ornamentalDivider} alt="" aria-hidden="true" sx={{ width: "120px", height: "11px" }} />
  </Box>
);
